import { render, staticRenderFns } from "./OrderFailed.vue?vue&type=template&id=98448c94&scoped=true&"
import script from "./OrderFailed.vue?vue&type=script&lang=js&"
export * from "./OrderFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98448c94",
  null
  
)

export default component.exports